import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { styled, alpha }, "@mui/material/AppBar": AppBar, "@mui/material/Box": Box, "@mui/material/Toolbar": Toolbar, "@mui/material/IconButton": IconButton, "@mui/material/Typography": Typography, "@mui/material/InputBase": InputBase, "@mui/material/Badge": Badge, "@mui/material/MenuItem": MenuItem, "@mui/material/Menu": Menu, "@mui/icons-material/Menu": MenuIcon, "@mui/icons-material/Search": SearchIcon, "@mui/icons-material/AccountCircle": AccountCircle, "@mui/icons-material/Mail": MailIcon, "@mui/icons-material/Notifications": NotificationsIcon, "@mui/icons-material/MoreVert": MoreIcon } } });
export default ClientProvider;
